import React from 'react';
import {Outlet} from "react-router-dom";

const CommonRoute = () => {
	return <Outlet/>
};

export default CommonRoute;